import React from 'react';
import { Box, BoxExtendedProps, Option } from '@common-fe/common-fe';

import theme from '@/styles/theme';

import FieldSetupOption from './FieldSetupOption';

export interface FieldSetupOptionWithGridColumn extends Option<string> {
  gridColumn?: string;
}

interface Props extends BoxExtendedProps {
  testId?: string;
  value?: string;
  onChangeValue?: (value: string) => void;
  onCreateValue?: (value: Record<string, string>) => void;
  options?: FieldSetupOptionWithGridColumn[];
  style?: React.CSSProperties;
}

const FieldSetupOptions: React.FC<Props> = ({
  testId,
  value,
  onChangeValue,
  onCreateValue,
  options,
  style,
  ...props
}) => {
  return (
    <Box
      data-testId={`${testId}-field-setup-options`}
      direction="row"
      style={{ gap: theme.spacings.spacing12, ...style }}
      {...props}
    >
      {options?.map((option) => (
        <FieldSetupOption
          testId={testId}
          key={option?.key}
          title={option?.title}
          value={option?.value}
          additionalValue={option?.additionalValue}
          isActive={option?.value === value}
          onChangeValue={onChangeValue}
          onCreateValue={onCreateValue}
          metadata={option?.metadata}
          node={option?.node}
          gridColumn={option?.gridColumn}
          maxItemWidth={option?.maxItemWidth}
        />
      ))}
    </Box>
  );
};

export default FieldSetupOptions;
